import { useEffect } from "react";
import { Loader2 } from "lucide-react";
import useSettings from "@/hooks/useSettings";

export default function Prenota() {
  const s = useSettings();
  useEffect(() => {
    if (s?.calendly_url) window.location.replace(s.calendly_url);
  }, [s]);
  return (
    <main className="min-h-screen bg-[#F9F7F3] flex flex-col items-center justify-center gap-4 text-[#5A625C]" data-testid="prenota-page">
      <Loader2 className="w-6 h-6 animate-spin text-[#C05746]" />
      <p className="font-display text-2xl text-[#1E231F]">Ti porto al calendario di Chiara…</p>
    </main>
  );
}
